import { Directive } from "@angular/core";
import { classes } from "@spartan-ng/helm/utils";

/**
 * O2 Sheet Header Directive
 *
 * Fixed header section for the sheet.
 * Apply to any element to mark it as sheet header.
 * Removes default padding for custom layout control.
 *
 * Usage:
 * <div o2SheetHeader>
 *   <h2 o2SheetTitle>Title</h2>
 *   <p class="text-sm text-muted-foreground mt-2">Description</p>
 * </div>
 */
@Directive({
  selector: "[o2SheetHeader]",
  standalone: true,
})
export class O2SheetHeaderDirective {
  constructor() {
    classes(() => "p-0");
  }
}
